import '@descope-ui/descope-enriched-text';
import { componentName, AlertClass } from './AlertClass';

customElements.define(componentName, AlertClass);

export { AlertClass, componentName };
